import { createPinia, setActivePinia } from 'pinia';
import { toRaw } from 'vue';
import { useMainStore } from '../store/index';
import { useLoaderStore } from '../store/loader';
import { useFullSpinnerStore } from '../store/fullSpinner';
import { useNotificationBarStore } from '../store/notificationbar';

export default defineNuxtPlugin({
  name: 'pinia',
  setup(nuxtApp) {
    const pinia = createPinia();

    nuxtApp.vueApp.use(pinia);
    setActivePinia(pinia);

    if (nuxtApp.payload?.pinia) {
      pinia.state.value = nuxtApp.payload.pinia;
    }

    if (import.meta.server) {
      nuxtApp.hooks.hook('app:rendered', () => {
        nuxtApp.payload.pinia = toRaw(pinia.state.value);
        setActivePinia(undefined);
      });
    }

    return {
      provide: {
        pinia,
        store: useMainStore(pinia),
        loader: useLoaderStore(pinia),
        fullSpinner: useFullSpinnerStore(pinia),
        notificationbar: useNotificationBarStore(pinia)
      }
    };
  }
});
